<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>


import { getToken } from "@/utils/auth";
import { getWebsocket } from "@/api/websocket"; 
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      ws: null,
      url: '',
      st: null,
    };
  },
  computed: {
    ...mapGetters([
      'wslogin',
    ])
  },
  watch:{
    wslogin(val){
      if(val){
        this.startWebsocket();
      } else {
        this.stopWebsocket();
      }
      console.log('wslogin')
    }
  },
  created() { 
    //  this.startWebsocket();
    // this.$store.watch(
    //   (state) => state.wslogin,
    //   (newVal, oldVal) => {
    //     console.log('Store级监听 - 用户信息变更:', newVal);
    //   },
    //   { immediate: true } // 可选：立即执行一次
    // );
  },
  methods: {
    //获取websocket位置文件
    startWebsocket(){ 
      getWebsocket().then(response => {
        this.url = response.data.data.ws 
        console.log(['登录获取websocket 数据库配置网址',this.url])
        if (this.url != ''){
          this.initWebSocket();
        }
      });
    },
    stopWebsocket() { 
      if (this.ws != null){
        this.ws.close(); 
        this.ws = null;
      }   
    },
    initWebSocket() { 
      //初始化websocket
      if ("WebSocket" in window) { 
        if (this.ws!=null){
          this.ws.close(); 
          this.ws=null;
        }    
        const wsuri = this.url; //ws地址 
        console.log(['new websocket',wsuri]); 
        this.ws  = new WebSocket(wsuri);  
        this.ws.onclose = this.websocketclose;
        this.websocket.setWs(this.ws);
      } else {
        this.websocket.setColor("red");
        this.websocket.setTip("您的浏览器不支持 WebSocket!");
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    }, 
    websocketonerror(e) {
      //错误 
      this.ws=null;
      this.websocket.setColor("red");
      this.websocket.setTip("WebSocket连接发生错误");   
    }, 
    websocketclose(e) { 
      this.ws=null;
      this.websocket.setColor("gray");
      this.websocket.setTip("WebSocket服务端关闭");    
      setTimeout(this.initWebSocket(), 5000);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue